/*
 * @Author: ken yang
 * @Date: 2022-09-28 19:44:55
 * @LastEditTime: 2023-01-30 10:49:59
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/view/activity/index.js
 */
import AppLayout from '@/layout/AppLayout.vue'
const RegisterSendBTC = () => import('@/view/activity/RegisterSendBTC.vue')
const NewcomerBenefits = () => import('@/view/activity/NewcomerBenefits.vue')
const Christmas = () => import('@/view/activity/christmas/Christmas.vue')
const CommonActivity = () => import('@/view/activity/CommonActivity.vue')
const ActivityParticipation = () => import('@/view/activity/ActivityParticipation.vue')
const SuperNode = () => import('@/view/activity/SuperNode.vue')
const SuperNodeSubscribe = () => import('@/view/activity/superNode/Subscribe.vue')
const EcoActivity = () => import('@/view/activity/eco/index.vue')
const EcoHome = () => import('@/view/activity/ecoV2/EcoHome.vue')
const WorldCupActivity = () => import('@/view/activity/worldCup/index.vue')
const HashrateSubscription = () => import('@/view/activity/ecoV2/HashrateSubscription.vue')
const Repurchase = () => import('@/view/activity/ecoV2/Repurchase.vue')
const StakingPurchase = () => import('@/view/activity/ecoV2/StakingPurchase.vue')
const Portfolio = () => import('@/view/activity/ecoV2/portfolio/index.vue')
const Recommend = () => import('@/view/activity/ecoV2/Recommend/index.vue')
const IpoQuota = () => import('@/view/activity/ecoV2/pages/IpoQuota.vue')
const CommunityRewards = () => import('@/view/activity/ecoV2/pages/CommunityRewards.vue')

const ecoV2AuthMeta = (header) => ({
  header,
  requireLogin: true,
})

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/registerSendBTC',
        component: RegisterSendBTC,
      },
      {
        path: '/newcomerBenefits',
        component: NewcomerBenefits,
      },
      {
        path: '/christmas',
        component: Christmas,
      },
      {
        path: '/commonActivity',
        component: CommonActivity,
      },
      {
        path: '/activityParticipation',
        component: ActivityParticipation,
        props: route => ({ ...route.query }),
      },
      {
        path: '/superNode',
        component: SuperNode,
      },
      {
        path: '/superNode/subscribe',
        component: SuperNodeSubscribe,
      },
      {
        path: '/eco',
        component: EcoActivity,
        meta: { header: 'eco' },
      },
      {
        path: '/activity/worldCup',
        component: WorldCupActivity,
      },
      {
        path: '/ecoHome',
        redirect: to => ({
          path: '/ecoV2/ecoHome',
          query: to.query,
          hash: to.hash,
        }),
      },
      {
        path: '/ecoV2/ecoHome',
        component: EcoHome,
        meta: ecoV2AuthMeta('EcoHome'),
      },
      {
        path: '/ecoV2/HashrateSubscription',
        component: HashrateSubscription,
        meta: ecoV2AuthMeta('HashrateSubscription'),
      },
      {
        path: '/ecoV2/Repurchase',
        component: Repurchase,
        meta: ecoV2AuthMeta('Repurchase'),
      },
      {
        path: '/ecoV2/StakingPurchase',
        component: StakingPurchase,
        meta: ecoV2AuthMeta('StakingPurchase'),
      },
      {
        path: '/ecoV2/portfolio',
        component: Portfolio,
        meta: ecoV2AuthMeta('portfolio'),
      },
      {
        path: '/ecoV2/Recommend',
        component: Recommend,
        meta: ecoV2AuthMeta('Recommend'),
      },
      {
        path: '/ecoV2/IpoQuota',
        component: IpoQuota,
        meta: ecoV2AuthMeta('IpoQuota'),
      },
      {
        path: '/ecoV2/CommunityRewards',
        component: CommunityRewards,
        meta: ecoV2AuthMeta('CommunityRewards'),
      },
    ],
  },
]
const components = {}
export default {
  routes,
  components,
}
